import { useState } from "react";
import { useAuthState } from "../../context/AuthContext";
import PrivateApi from "../../services/PrivateApiService";
import Validator from "../../services/Validator";
import { Button, Card, CardBody, Col, Container, Row, Spinner } from "react-bootstrap";
import Steper from "../../components/shared/Steper";
import NameMask from "../../components/form_masks/building/new/NameMask"
import AddressMask from "../../components/form_masks/building/new/AddressMask";
import AbrechnungMask from "../../components/form_masks/building/new/AbrechnungMaks";
import AnlagenMask from "../../components/form_masks/building/new/AnlagenMask";
import EmployeeMask from "../../components/form_masks/share/EmployeeMask";
import SummaryMask from "../../components/form_masks/building/new/SummaryMask";
import DoneMask from "../../components/form_masks/share/DoneMask";
import ErrorMask from "../../components/form_masks/share/ErrorMask";

const NewBuildingPage = () => {

    // ! -------------
    // ! Global vars |
    // ! -------------
    const { contactPerson } = useAuthState();
    const API = new PrivateApi();
    const VALIDATOR = new Validator();
    const [apiError, setApiError] = useState("");

    // * Masks vars
    const [isLoading, setIsLoading] = useState(false);
    const [places, setPlaces] = useState([]);
    const [step, setStep] = useState("contactPerson");
    const defaultBuildingData = {
        building_name: "",
        building_ident: "",
        vorgang: "Erstbezugsobjekt",
        oldHw: "",
        country_id: "12",
        state_id: "",
        zip: "",
        city: "",
        street: "",
        houseNr: "",
        noUid: false,
        uid: "",
        building_account_owner: "",
        building_iban: "",
        pool_start: "",
        noVollmacht: false,
        vollmacht: {},
        contact: contactPerson,
        anlagen: [],
    }
    const [data, setData] = useState(defaultBuildingData);
    const [formError, setFormError] = useState({});
    const buildingStepIndicator = [
        {id: "step1", key: "contactPerson", title: "Kontaktperson"},
        {id: "step2", key: "name", title: "Name"},
        {id: "step3", key: "address", title: "Adresse"},
        {id: "spte4", key: "abrechnung", title: "Abrechnung"},
        {id: "step5", key: "anlagen", title: "Anlagen"},
        {id: "step6", key: "summary", title: "Ihre Zusammenfassung"}
    ];
    

    // ! -----------
    // ! Functions |
    // ! -----------
    // * Bach button handler
    const backButtonHandler = () => {
        const index = buildingStepIndicator.findIndex((i) => i.key === step);
        if (index > 0) {
            setStep(buildingStepIndicator[index -1].key);
        }
    }

    // * Next button handler
    const nextBtnHandler = () => {
        // check for form errors
        var tmpError = {};
        if (step === "name") {
            if (data.building_name.length < 4) tmpError.building_name = true;
            if (data.bulding_ident === "") tmpError.bulding_ident = true;
            if (data.vorgang === "") tmpError.vorgang = true;
        }
        if (step === "address") {
            if (data.country_id === "") tmpError.country_id = true;
            if (data.country_id === "12" && data.state_id === "") tmpError.state_id = true;
            if (!VALIDATOR.isValidZip(data.country_id, data.state_id, data.zip)) tmpError.zip = true;
            if (places.length > 0) {
                if (!places.includes(data.city) || data.city === "") tmpError.city = true;
            } else {
                if (data.city === "" || data.city.length < 3) tmpError.city = true; 
            }
            if (!VALIDATOR.StringLength(3, 80, data.street)) tmpError.street = true;
            if (data.houseNr === "") tmpError.houseNr = true;
        }
        if (step === "abrechnung") {
            if (!data.noUid && !VALIDATOR.vatValid(data.uid)) tmpError.uid = true;
            if (data.building_account_owner.length < 4) tmpError.building_account_owner = true;
            if (!VALIDATOR.ibanValid(data.building_iban.replace(/\s+/g, ''))) tmpError.building_iban = true;
            if (data.pool_start === "" || !VALIDATOR.dateValid(data.pool_start)) tmpError.pool_start = true;
            if (!data.noVollmacht && data.vollmacht.file === undefined) tmpError.vollmacht = true;
        }

        // next pressed on summary send data to backend
        if (step === "summary") {
            return sendData();
        }

        // if tmpError has errors return them
        if (Object.keys(tmpError).length > 0) {
            return setFormError(tmpError);
        }

        // go to next step
        const index = buildingStepIndicator.findIndex(i => i.key === step);
        setStep(buildingStepIndicator[index + 1].key);
    }

    const sendData = () => {
        setIsLoading(true);
        API.hw_BuildingsNew(data)
            .then(() => setStep("done"))
            .catch(err => {
                if (err.response.data.detail && err.response.data.detail !== "") {
                    setApiError(err.response.data.detail)
                } else {
                    setApiError("Unbekanter Fehler aufgetreten.")
                }
                setStep("error");
            })
            .finally(() => setIsLoading(false));
    }

    // ! -----
    // ! GUI |
    // ! -----
    return (
        <Container>
            <Row>
                <Col>
                    <h3>Neue Liegenschaft</h3>
                    <p className="text-muted">Hier können Sie eine Liegenschaft und dazugehörige Anlagen hinzufügen</p>
                </Col>
            </Row>
            <Row className="mt-3 justify-content-center">
                <Col xs="12" md="10" xl="10">
                    <Card style={{borderRadius: 15, borderBottom: "6px solid #a2c13f"}} className="shadow-lg">
                        <CardBody>
                            <Steper step={step} data={buildingStepIndicator} />
                            {
                                step === "contactPerson" ? 
                                    <EmployeeMask formData={data} setFormData={setData} formError={formError} setFormError={setFormError} nextHandler={nextBtnHandler} /> :
                                step === "name" ? 
                                    <NameMask data={data} setData={setData} formError={formError} setFormError={setFormError} /> :
                                step === "address" ?
                                    <AddressMask data={data} setData={setData} formError={formError} setFormError={setFormError} setPlaces={setPlaces} /> :
                                step === "abrechnung" ?
                                    <AbrechnungMask data={data} setData={setData} formError={formError} setFormError={setFormError} /> :
                                step === "anlagen" ? 
                                    <AnlagenMask data={data} setData={setData} setPlaces={setPlaces} setMainStep={setStep} /> :
                                step === "summary" ?
                                    <SummaryMask data={data} setStep={setStep} /> :
                                step === "done" ?
                                    <DoneMask message={"Vielen Dank! Wir haben die Daten zur Liegenschaft erhalten und werden Sie in Kürze bearbeiten."} /> :
                                step === "error" ?
                                    <ErrorMask error={apiError}/> : 
                                null
                            }
                            <Row className="mt-3" hidden={step === "anlagen" || step === "error" || step === "done"}>
                                <Col className="text-end">
                                    <Button
                                        disabled={isLoading}
                                        hidden={buildingStepIndicator[0].key === step}
                                        className="me-2"
                                        variant="warning"
                                        onClick={backButtonHandler}
                                    >
                                        Zurück
                                    </Button>
                                    <Button 
                                        disabled={isLoading}
                                        hidden={buildingStepIndicator[0].key === step}
                                        variant="energo"
                                        onClick={nextBtnHandler}
                                    >
                                        {
                                            isLoading ? 
                                                <Spinner animation="border" /> :
                                            step === "summary" ?
                                                "Absenden" :
                                                "Weiter"
                                        }
                                    </Button>
                                </Col>
                            </Row>
                            <Row className="mt-3" hidden={step !== "error"}>
                                <Col className="text-end">
                                    <Button
                                        disabled={isLoading}
                                        className="btn-warning me-2"
                                        onClick={() => setStep("summary")}
                                    >Zurück</Button>
                                    <Button
                                        disabled={isLoading}
                                        variant="energo"
                                        onClick={() => sendData()}
                                    >
                                        {isLoading ?
                                            <Spinner animation="border" /> :
                                            "Erneut versuchen"
                                        }
                                    </Button>
                                </Col>
                            </Row>
                            <Row className="mt-3" hidden={step !== "done"}>
                                <Col className="text-center">
                                    <a href="/hw/dashboard/" className="btn btn-energo">Zum Dashboard</a>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </Container>
    )
}
export default NewBuildingPage;